// ABOUTME: SPEC-76 — reads the first-visit tutorial's READ copy from /api/config for the gate's read-first panel.
// ABOUTME: Boundary validation only: malformed or absent copy means the tenant has no such panel.

/**
 * The tutorial copy the server sends in `/api/config` (`first_visit_tutorial`), validated at the boundary.
 * Returns null unless it is well-formed — the panel then simply does not exist (never a broken panel). The key is ABSENT
 * for every tenant but the one whose profile turns the feature on, so nothing renders anywhere else.
 *
 * (The SPOKEN tutorial and its topics live entirely on the server; the words on screen while it is spoken are the
 * ordinary closed captions — the owner dropped the separate typed card on 2026-09-29 for exactly that reason.)
 */
export function readCopy(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const strings = (list) => (Array.isArray(list) ? list.filter((s) => typeof s === 'string' && s.trim()) : []);
  const paragraphs = strings(raw.paragraphs);
  const title = typeof raw.title === 'string' ? raw.title.trim() : '';
  const closing = typeof raw.closing === 'string' ? raw.closing.trim() : '';
  if (!title || !paragraphs.length || !closing) return null;
  const prompt = typeof raw.primer_prompt === 'string' ? raw.primer_prompt.trim() : '';
  return { title, paragraphs, closing, primerPrompt: prompt };
}
